import { FaQuoteLeft } from 'react-icons/fa';

const testimonials = [
  {
    id: 1,
    name: 'Nitin',
    role: 'High School Student',
    content: 'I went to the institute and had a splendid time. I got to learn the most difficult concepts in an easy way and no matter how many doubts were always acknowledged and cleared and i scored marks beyond my expectations in 10th and 12th boards all because of the multiple practice sessions held by faculty. I recommend to everyone to go here if they need help, guidance and score good marks.',
    //avatar: 'https://randomuser.me/api/portraits/women/32.jpg',
  },
  {
    id: 2,
    name: 'Kartik Aggrawal',
    role: 'High School Student',
    content: 'An excellent maths tutor-patient, extremely intelligent, and genuinely helpful. Concepts that once felt difficult were explained clearly and calmly, without ever rushing. Their teaching style builds both understanding and confidence. I had taken classes from 7th standard to 12th and achieved top scores. Highly recommended for anyone looking to strengthen their maths fundamentals or tackle advanced topics with clarity.',
    //avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
  },
  {
    id: 3,
    name: 'Guneet Mongia',
    role: 'IB Student',
    content: 'Was a student for mathematics this time last year for my A levels. Immensely improved my marks, I got confident in my concepts and picked up my solving speed. Ma’am really helpful and understanding, she will slow down and explain if you get stuck anywhere in a problem. Definitely recommended.',
    //avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
];

const Testimonials = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            What Our Students Say
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Don't just take our word for it - hear from our students and parents
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white p-8 rounded-lg shadow-md">
              <div className="relative">
                <FaQuoteLeft className="h-8 w-8 text-blue-100 absolute -top-4 -left-2" />
                <p className="relative text-gray-700 italic">{testimonial.content}</p>
              </div>
              <div className="mt-6 flex items-center">
                {/* <img 
                  className="h-12 w-12 rounded-full" 
                  src={testimonial.avatar} 
                  alt={testimonial.name} 
                /> */}
                <div className="ml-4">
                  <p className="text-lg font-medium text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
